const pieChart = {
    toolbox: {
        show: true,
        feature: {
            // restore: { title: "Refresh Data" },
            saveAsImage: {
                title: "Save Image"
            }
        }
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
        itemHeight: 10,
        itemWidth: 10,
        data: ['Milk', 'Coffee', 'Water', ],
        textStyle: {
            color: '#999'
        }
    },
    color: ['#f8b425', '#050505', '#02a499', '#6f42c1', '#9aa2ea'],
    series: [
        {
            type: 'pie',
            radius: '60%',
            center: ['50%', '48%'],
            data: [
                { value: 335, name: 'Milk' },
                { value: 310, name: 'Coffee' },
                { value: 1548, name: 'Water' }
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};



export { pieChart};
